import type { ComponentType } from "react";

import { cn } from "../lib/utils";

/**
 * Icon rules for every v2 component (DESIGN.md "UI icons (v2)", #455).
 *
 * Components take an icon as a COMPONENT (`leadingIcon={Plus}`), not as an
 * element, and render it through `<Icon>`. Size and stroke are then set by the
 * component, so callers pass no props and no descendant-selector classes are needed.
 */

/** The one stroke width for every icon (decided 05.10.2026). */
export const ICON_STROKE = 1.75;

/** 12 with caption/micro text and badges, 16 with body text and in every control, 20 with headings and empty states. */
export type IconSize = 12 | 16 | 20;

/** Any lucide icon fits; custom icons (e.g. the AI marker) take the same props. */
export type IconComponent = ComponentType<{
  size?: number | string;
  strokeWidth?: number | string;
  className?: string;
  "aria-hidden"?: boolean | "true" | "false";
}>;

export function Icon({
  icon: Component,
  size = 16,
  className,
}: {
  icon: IconComponent;
  size?: IconSize;
  className?: string;
}) {
  // Decorative: the control around it carries the accessible name.
  return <Component size={size} strokeWidth={ICON_STROKE} aria-hidden="true" className={cn("shrink-0", className)} />;
}
